<template>
  <div>
    <h1>Запрос для выписки</h1>
    <h2>{{ this.token }}</h2>
  </div>
</template>

<script>
export default {
  name: 'MemberRequestExtract',
  data () {
    return {
      token: null
    }
  },
  mounted () {
    this.token = this.$route.params.token
  }
}
</script>

<style scoped>

</style>
